<template>
  <FarmsTable
    ref="FarmsTable"
    :idFarm="item.ID"
    :editorName="item.EDITOR_NAME"
    :lastUpdate="item.UPDATE"
    :title="title"
  />
</template>

<script>
import FarmsTable from "./FarmsTable";

export default {
  components: {
    FarmsTable,
  },
  props: {
    itemSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    item() {
      return this.itemSelected;
    },
    title() {
      return this.item.ID ? `Cultivar ${this.item.ID}` : " ";
    },
  },
  created() {
    // console.log("created farms")
  },
};
</script>
